export default "__VITE_ASSET__CeWljgD4__"